import { render, staticRenderFns } from "./pqcesForm.vue?vue&type=template&id=668dc752&"
import script from "./pqcesForm.vue?vue&type=script&lang=js&"
export * from "./pqcesForm.vue?vue&type=script&lang=js&"
import style0 from "./pqcesForm.vue?vue&type=style&index=0&id=668dc752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports